const initialState = {
  isCompAllEvent: false,
};

function groupsStubhubSeatingState(state = initialState, action) {
  switch (action.type) {
    case 'SET_COMP_ALL_EVENT':
      return { ...state, isCompAllEvent: action.payload };
    default:
      return state;
  }
}

export default groupsStubhubSeatingState;
